export const Sparkle = ({ className = "", fill = "#3CE882", stroke = "#0A0A0A", strokeWidth = 7 }) => (
  <svg viewBox="0 0 100 100" className={className} fill="none" aria-hidden="true">
    <path
      d="M50 3 C55.5 31 69 44.5 97 50 C69 55.5 55.5 69 50 97 C44.5 69 31 55.5 3 50 C31 44.5 44.5 31 50 3 Z"
      fill={fill}
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinejoin="round"
    />
  </svg>
);

export const Globe = ({ className = "" }) => (
  <svg viewBox="0 0 100 100" className={className} fill="none" aria-hidden="true">
    <circle cx="50" cy="50" r="46" fill="#0A0A0A" />
    <circle cx="50" cy="50" r="46" stroke="#F4F4F0" strokeWidth="5" />
    <ellipse cx="50" cy="50" rx="21" ry="45" stroke="#F4F4F0" strokeWidth="4" />
    <line x1="50" y1="4" x2="50" y2="96" stroke="#F4F4F0" strokeWidth="4" />
    <line x1="5" y1="50" x2="95" y2="50" stroke="#F4F4F0" strokeWidth="4" />
    <path d="M11 29 H89" stroke="#F4F4F0" strokeWidth="4" />
    <path d="M11 71 H89" stroke="#F4F4F0" strokeWidth="4" />
  </svg>
);

export const CursorArrow = ({ className = "" }) => (
  <svg viewBox="0 0 24 26" className={className} fill="none" aria-hidden="true">
    <path
      d="M4.5 2 L20.5 10.5 L13 13.2 L16.6 22.5 L13.2 23.8 L9.6 14.6 L4.5 19 Z"
      fill="#12A94F"
      stroke="#F4F4F0"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
);

export const ArrowDiag = ({ className = "" }) => (
  <svg viewBox="0 0 24 24" className={className} fill="none" aria-hidden="true">
    <path d="M7 17 L17 7 M17 7 H8 M17 7 V16" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
